import { postData } from "./axiosConfig"

export const applyCopoun = async (body) => {
    return await postData("/user/coupon/apply", body)
}

export const placeOrder = async (body) => {
    return await postData("/user/order/place-order", body)
}


